module.exports = __webpack_public_path__ + "img/qrcode_shoukuan.8ea6e338.jpg";